
/* eslint-disable vue/no-mutating-props */
// `target` is one attendee from state.attendees; `primary` is state.primary —
// both orchestrator-owned, mutated in place.
import { COPY } from './copy'
import { fillFromRecord } from './logic'
import CrmSearch from './CrmSearch.vue'
import ClientInfoCard from './ClientInfoCard.vue'
import ReturningClientFields from './ReturningClientFields.vue'
import ReferralFields from './ReferralFields.vue'
import UpcomingApptNotice from './UpcomingApptNotice.vue'

export default {
    components: { CrmSearch, ClientInfoCard, ReturningClientFields, ReferralFields, UpcomingApptNotice },
    props: {
        target: { type: Object, required: true },
        primary: { type: Object, required: true },
        excludeIds: { type: Array, default: () => [] },
        // clientId -> soonest upcoming appointment (or null), owned by the
        // orchestrator; keyed lookup so each attendee reads only its own.
        upcomingByClientId: { type: Object, default: () => ({}) },
    },
    data () {
        return { COPY }
    },
    computed: {
        upcoming () {
            const id = this.target.record && this.target.record.id
            return id ? (this.upcomingByClientId[id] || null) : null
        },
    },
    methods: {
        set (key, val) {
            this.$set(this.target, key, val)
        },
        setPill (key, val) {
            this.set(key, val)
            if (key === 'returning' && !val) this.set('record', null)
        },
        onPick (row) {
            // Mirrors the mockup's attPick: carry the CRM basics over so the
            // gates/summary/SOA card all read from the attendee itself.
            this.set('record', row)
            this.set('first_name', row.first_name || '')
            this.set('last_name', row.last_name || '')
            this.set('dob', row.dob || null)
            this.set('gender', row.gender || null)
            this.set('email', row.email || '')
            // Prefill the editable on-file fields (phone, ZIP/county, address,
            // parts) so the admin can correct them in ReturningClientFields.
            // Coverage date is pointedly not among them — see fillFromRecord.
            fillFromRecord(this.target, row)
            this.$emit('pick', row)
        },
        syncFromClient () {
            const src = this.primary.returning && this.primary.record ? this.primary.record : this.primary
            const zip = src.zip_code || ''
            // The live person, never the CRM record: coverage is no longer
            // prefilled from file (see fillFromRecord), so the only meaningful
            // date is the one the admin just typed on the client.
            const cov = this.primary.effective_date || null
            if (!zip && !cov) {
                this.$alert({ message: COPY.s3.syncToastEmpty, variant: 'warning' })
                return
            }
            if (zip) {
                this.set('zip_code', zip)
                this.set('fips', src.fips || null)
                this.set('state', src.state || null)
                this.set('county', src.county || null)
                this.set('counties', src.counties ? [...src.counties] : [])
                // Fix 4 (final-review wave, #680): the block above already
                // treats zip as the "same address" trigger — pull the street
                // too, so "same as client" actually copies the same address
                // instead of leaving a stale/blank street paired with a new
                // zip/state.
                this.set('street_1', src.street_1 || '')
                this.set('street_2', src.street_2 || '')
                this.set('city', src.city || '')
            }
            if (cov) this.set('effective_date', cov)
            this.$alert({ message: COPY.s3.syncToast(zip, cov), variant: 'success' })
        },
    },
}
